import React from "react";

export default function PrivacyPolicy() {
  return (
    <>
      <div className="max-w-4xl mx-auto my-10 p-8 bg-white shadow-lg rounded-lg">
        <h1 className="text-4xl text-center font-bold text-[#124e66] mb-8">
          Privacy Policy
        </h1>
        <div className="space-y-6 text-justify leading-7">
          <p className="text-lg">
            <i className="font-semibold">1. Information We Collect:</i>
            <span className="ml-2">
              To deliver our content production services, Professionals
              Spotlight needs personal information from you, like your name,
              email address, professional history, and business specifics. When
              you submit this information during the ordering process, it is
              directly obtained from you.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">2. How We Use Your Information:</i>
            <span className="ml-2">
              Our data collection process is employed in the production and
              distribution of customized articles and biographies. Additionally,
              we might use the information you provide to better serve you, keep
              in touch with you about updates and changes, and improve your
              online experience.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">3. Sharing Your Information:</i>
            <span className="ml-2">
              Your personal information is never sold, traded, or shared with
              outside parties unless it's required to carry out our services,
              such as when your biography is posted on Executives Diary or
              another website. All of our third-party partners are obligated to
              respect your privacy and use your information solely for that
              purpose.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">4. Data Security:</i>
            <span className="ml-2">
              Professionals Spotlight is concerned about protecting the privacy
              of your personal data. We will prevent unauthorized access and
              misuse of your information by using industry-standard security
              procedures.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">5. Cookies and Tracking:</i>
            <span className="ml-2">
              Cookies and related technologies are used on our website to
              monitor user activity and measure website traffic. It improves
              your browsing experience too. Through your browser's options, you
              can adjust your cookie preferences; however, doing so might make
              some website services inoperable.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">6. Your Rights:</i>
            <span className="ml-2">
              You possess the entitlement to obtain, amend, or erase any
              personal data that we may have about you. Please stay in touch
              with us to use these privileges. We promise to reply to your
              queries and requests as soon as possible.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">7. Retention of Data:</i>
            <span className="ml-2">
              We will only retain your personal information for as much time as
              it takes to fulfill your request for services. If you would like
              your information to be deleted, please contact us. We will do what
              is necessary to ensure that it does not conflict with any legal
              obligations.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">8. Changes to Privacy Policy:</i>
            <span className="ml-2">
              Professionals Spotlight reserves the right to make changes to
              current policies at any time. Any modifications will be updated on
              this page. By using our services going forward, you agree to the
              most recent version of the policy.
            </span>
          </p>

          <p className="text-lg">
            <i className="font-semibold">9. Contact Us:</i>
            <span className="ml-2">
              For questions regarding this Privacy Policy or to exercise your
              rights, please contact us at  
              <strong className="ml-1 text-[#124e66] ">
              Admin@Professionals-Spotlight.com.
              </strong>
            </span>
          </p>
        </div>
      </div>
    </>
  );
}
